<template>
  <div v-if="isShow" class="data-overview">
    <order-overview :is-demo="isDemo" />
    <abnormal-monitoring :is-demo="isDemo" />
    <order-statistics :is-demo="isDemo" />
    <a-row type="flex" :gutter="16">
      <a-col :span="12">
        <goods-stock />
      </a-col>
      <a-col :span="12">
        <transport :is-demo="isDemo" />
      </a-col>
    </a-row>
    <a-row type="flex" :gutter="16">
      <a-col :span="12">
        <table-item :is-demo="isDemo" :title="'线路TOP10'" :columns="lineColumns" :type="'line'" />
      </a-col>
      <a-col :span="12">
        <table-item :is-demo="isDemo" :title="'货品流向TOP10'" :columns="goodsColumns" :type="'goods'" />
      </a-col>
    </a-row>
    <a-row type="flex" :gutter="16">
      <a-col :span="12">
        <table-item :is-demo="isDemo" :title="'货品明细运输TOP10'" :columns="detailedColumns" :type="'detailed'" />
      </a-col>
      <a-col :span="12">
        <table-item :is-demo="isDemo" :title="'货品品类运输TOP10'" :columns="categoryColumns" :type="'category'" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapMutations,mapActions } from 'vuex'
import {postTrack} from '@/utils/point'
import {RULE_TYPE} from '@/constants/ruleConfig'
import OrderOverview from './components/OrderOverview.vue'
import AbnormalMonitoring from './components/Abnormal.vue'
import OrderStatistics from './components/OrderStatistics.vue'
import GoodsStock from './components/GoodsStock.vue'
import Transport from './components/Transport.vue'
import TableItem from './components/TableItem.vue'
import { lineColumns, goodsColumns, detailedColumns, categoryColumns } from "./constant.js"
import {projectList, getConfig} from './api'

export default {
  name: 'DataOverview',
  components: {
    OrderOverview,
    AbnormalMonitoring,
    OrderStatistics,
    GoodsStock,
    Transport,
    TableItem,
  },
  data() {
    return {
      lineColumns, goodsColumns, detailedColumns, categoryColumns,
      isShow:false,
      isDemo: false,
    }
  },
  async created(){
    await this.getOrderCrop(RULE_TYPE.sensitiveFields)
    this.isShow=false
    this.getAutoProject();
    this.postTrackFn();
  },
  methods:{
    ...mapMutations('user', ['SET_USER_DATA']),
    ...mapActions('orderRules', ['getOrderCrop']),
    async getAutoProject(){
        const {creditCode,userId, customerCode}=this.$store.state.user
              const data = {
                  accountId: userId,
                  relationType: 'DOWN',
                  orgType: 'PROJECT',
                  accountType: 'CUSTOMER',
                  orgStatus: 'ENABLED'
              }
            if(creditCode){
                data.creditCode=creditCode
              }else{
                const accountData = JSON.parse(localStorage.getItem('accountData'))
                data.relationOrgId= accountData?.id
                // 不为企业视角时获取是否演示数据账号
                const configKeys = 'consignor.presentation.data'
                const configRes = await getConfig({
                  configKeys,
                })
                const presentationDataList =configRes[configKeys]
                if (presentationDataList.includes(customerCode)) {
                  this.isDemo = true
                }
              }
          try {
              const res= await projectList(data)
              const projectIds=res.map(item=>item.id)
              this.SET_USER_DATA(['projectIds',projectIds])
              this.isShow=true
          } catch (error) {
            this.isShow=true
          }
    },
    postTrackFn(){
      postTrack('数据分析-数据概览-订单概览')
      postTrack('数据分析-数据概览-异常监控')
      postTrack('数据分析-数据概览-近七日数据统计')
      postTrack('数据分析-数据概览-货品库存分析')
      postTrack('数据分析-数据概览-运费占比')
      postTrack('数据分析-数据概览-线路TOP10')
      postTrack('数据分析-数据概览-货品流向TOP10')
      postTrack('数据分析-数据概览-货品明细运输TOP10')
      postTrack('数据分析-数据概览-货品品类运输TOP10')
    }
  }
}
</script>
<style lang="less">
.data-overview {
  .overview {
    background: #fff;
    padding: 20px 0;
    margin-bottom: 15px;
    border-radius: 6px;
    .block-icon-right {
      flex: 1;
      text-align: right;
      margin-right: 32px;
    }
    .order-time {
      background: #F4F5F6;
      border-radius: 4px;
      .ant-radio-button-wrapper {
        &.ant-radio-button-wrapper-checked {
          border-radius: 4px;
        }
        &:not(.ant-radio-button-wrapper-checked) {
          background: #F4F5F6;
          border-color: #F4F5F6;
        }
        &:not(:first-child)::before {
          content: none;
        }
      }
    }
  }
  .all{
      display: inline-block;
      width: 24px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      font-size: 14px;
      color: #06B880;
      border: 1px solid #06B880;
      border-radius: 50%;
    }
    .one{
      color: #fff;
      background: #029869;
      border: 1px solid #029869;
    }
    .two{
      color: #fff;
      background: #06B880;
    }
    .three{
      color: #fff;
      background: #37c598;
      opacity: 0.5;
    }
}
</style>
